module.exports = __webpack_public_path__ + "img/signup-parta-3m-before-retire.9522d69.png";